import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-alert-overlay',
  standalone: true,
  imports: [],
  templateUrl: './alert-overlay.component.html',
  styleUrl: './alert-overlay.component.css'
})
export class AlertOverlayComponent {

  @Output() confirm = new EventEmitter<void>();

  remediateIssue() {
    this.confirm.emit();
  }
}
